





























































import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user.store";
import { UserEntity } from "@/models/userEntity";

@Component({
  components: {}
})
export default class LoginCardAuthorizationOverview extends Vue {
  constructor() {
    super();
  }

  get user(): UserEntity {
    return UserModule.user;
  }

  get permissions() {
    return UserModule.abilities["$"];
  }
}
